export const achievementData = {
    bio: "As a computer science student with a strong background in web development, I have gained a strong foundation in the skills and technologies necessary to build effective and engaging web applications. I've also completed this course, my achievements in web development courses show that I have the potential to become a successful and sought-after web developer. With continued learning and practice, I will be able to apply my skills to a wide range of projects and challenges in the field.",
    achievements: [
        {
            id: 1,
            title: 'Complete Web Development Course',
            details: "I've Complete Web Development Course with Jhankar Mahabub by Programming Hero, This a Full stack web development course",
            date: 'Jun 10, 2022',
            field: 'MERN Stack',
            image: 'https://web.programming-hero.com/static/media/course-thumbnail.923d12dd.jpg'
        },
        {
            id: 2,
            title: 'The Complete JavaScript Course ',
            details: "I've completed The Complete JavaScript Course by Udemy, This course helped me gain a deeper understanding of JavaScript",
            date: 'Aug 20, 2021',
            field: 'JavaScript',
            image: 'https://i.pinimg.com/originals/d1/d7/11/d1d7113a292af6ebbe146a83c8a752a5.png'
        },
        // {
        //     id: 3,
        //     title: 'Professional Data Engineer Certification',
        //     details: 'Professional Data Engineers enable data-driven decision making by collecting, transforming, and publishing data.',
        //     date: 'Aug 20, 2019',
        //     field: 'Automation',
        //     image: 'https://images.unsplash.com/photo-1489389944381-3471b5b30f04?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        // }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/